import { UserPermissions, UserSubscription } from '@creditsights/api-ui-web';
import { orderBy } from 'lodash';
import { DealMarketStatus } from '../../models/CompanyDeal';
import { Security, SecurityDocument } from '../../models/Securities';

const TABS_CONFIG: Record<UserSubscription, DealMarketStatus[]> = {
  [UserSubscription.CS_CR_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS_CR]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CR_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CR]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.RP]: [],
};

const OFFER_MEMORANDUM_TYPES = ['Offer Memorandum']; // 'Prospectus: Reds', 'Prospectus: Final'

// used also by @creditsights/creditsights-web MFE
export const getDealsTabs = ({ userSubscription }: UserPermissions): DealMarketStatus[] => {
  return TABS_CONFIG[userSubscription];
};

export const getDocumentUrl = (doc: SecurityDocument): string => {
  return `/api/common/v1/securities/deals/files/${doc.bond_id}/${encodeURIComponent(doc.doc_name)}`;
};

export const getOfferMemorandumDocument = (security: Security): SecurityDocument | null => {
  const documents = security?.docs?.filter((x) => OFFER_MEMORANDUM_TYPES.includes(x.doc_type));
  if (!documents?.length) {
    return null;
  }

  return orderBy(documents, (x) => x.doc_date, 'desc')[0];
};
